// extracted by mini-css-extract-plugin
module.exports = {"componentsRiskOrderInfo":"styles_componentsRiskOrderInfo__1rKhy"};